import { api } from "@/shared/libs/axiosClient";

/** SPT-4536: expired = 무응답으로 batch 가 자동 종결한 incident */
export type IncidentStatus = "open" | "acked" | "resolved" | "expired";
export type AckResolveStatus = "acked" | "resolved" | "expired";

export interface IncidentResponse {
  id: number;
  team_id: number;
  title: string;
  status: IncidentStatus;
  dedup_key: string | null;
  source: string | null;
  message: string | null;
  acked_at: string | null;
  created_at: string | null;
  ack_resolve_history: AckResolveHistory[];
}

export interface AckResolveHistory {
  id: number;
  incident_id: number;
  /** SPT-4536: 시스템(자동 만료) 행은 null */
  member_id: number | null;
  status: AckResolveStatus;
  created_at: string | null;
}

export interface AlertAttemptResponse {
  id: number;
  incident_id: number;
  member_id: number;
  channel: string;
  step: number;
  is_primary: boolean;
  attempt_no: number;
  status: string;
  provider_id: string | null;
  created_at: string | null;
}

export interface IncidentDetailResponse extends IncidentResponse {
  alert_attempts: AlertAttemptResponse[];
}

export interface IncidentCreate {
  title: string;
  dedup_key?: string;
  source?: "grafana" | "datadog" | "manual";
  message?: string;
}

export async function createIncident(
  teamId: number,
  data: IncidentCreate
): Promise<IncidentResponse> {
  return api.post<IncidentResponse>(`/team/${teamId}/incident`, data);
}

export async function fetchIncidents(teamId: number): Promise<IncidentResponse[]> {
  return api.get<IncidentResponse[]>(`/team/${teamId}/incident`);
}

/** SPT-4071: 인시던트 이력 페이지 (최신순) */
export interface IncidentPageResponse {
  items: IncidentResponse[];
  total: number;
  page: number;
  size: number;
}

export async function fetchIncidentHistory(
  teamId: number,
  page: number,
  size: number,
): Promise<IncidentPageResponse> {
  return api.get<IncidentPageResponse>(`/team/${teamId}/incident/history`, { params: { page, size } });
}

export async function getIncident(
  teamId: number,
  incidentId: number,
): Promise<IncidentDetailResponse> {
  return api.get<IncidentDetailResponse>(`/team/${teamId}/incident/${incidentId}`);
}

export async function ackIncident(teamId: number, incidentId: number): Promise<void> {
  return api.post<void>(`/team/${teamId}/incident/${incidentId}/ack`);
}

export async function resolveIncident(teamId: number, incidentId: number): Promise<void> {
  return api.post<void>(`/team/${teamId}/incident/${incidentId}/resolve`);
}
